import React  from 'react';
import Moment from 'moment-timezone';

import { currencyFormatter } from './formatters'

const formatCartDate = (timestamp) => Moment(timestamp.toDate()).format('L LT');

const formatCartOrder = (cartData) => {
      if (!cartData.totalOrderAmount) return '-';

      let currency = cartData.totalOrderAmountCurrency;

      if (!currency && cartData.orders) {
            const firstOrderKey = Object.keys(cartData.orders)[0];
            currency = cartData.orders[firstOrderKey]?.currency;
      }

      return currency
            ? currencyFormatter(currency, 2).format(cartData.totalOrderAmount)
            : '-';
};

const standaloneCartDataTableRow = ({ standaloneCartData, neededHost, showCartDate = true, showClientData = true, showHostName = true, showOrderDate = true, showAmount = true, }) => {
      const row = [];

      const clientDataCell = () => {
            const { customerFullName, customerEmail } = standaloneCartData;
            return (
                  <div>
                        <p>{customerFullName}</p>
                        <p>{customerEmail}</p>
                  </div>
            )
      };

      const hostDataCell = () => {
            const { email, firstName, lastName } = neededHost;

            return (
                  <div>
                        <p style={{ textTransform: 'capitalize' }}>{`${firstName} ${lastName}`}</p>
                        <p>{email}</p>
                  </div>
            )
      };

      const cartAmountCell = () => {
            return formatCartOrder(standaloneCartData);
      };

      const onPush = (cell) => {
            row.push((
                  <div>
                        {cell}
                  </div>
            ));
      };

      if (showCartDate) {
            onPush(formatCartDate(standaloneCartData.createdAt));
      }

      if (showClientData) {
            onPush(clientDataCell());
      }

      if (showHostName) {
            onPush(hostDataCell());
      }

      if (showOrderDate) {
            const orderDate = standaloneCartData.orderAt
                  ? formatCartDate(standaloneCartData.orderAt)
                  : '-';
            onPush(orderDate);
      }

      if (showAmount) {
            onPush(cartAmountCell());
      }

      return ({ row });
};

export default standaloneCartDataTableRow;
